import { Link } from "react-router-dom";
import logo from "@/assets/qa1st-logo.webp";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container-narrow px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <img src={logo} alt="QA 1st" className="h-10 w-10 rounded object-cover" />
              <h3 className="text-lg font-bold text-primary-foreground">QA 1st</h3>
            </div>
            <p className="text-primary-foreground/70 text-sm max-w-md">
              Intelligent quality systems for Ofsted-ready apprenticeship providers. We combine IQA expertise, AI dashboards and data-led frameworks to drive better outcomes.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-primary-foreground mb-3 text-sm">Pages</h4>
            <ul className="space-y-2 text-sm">
              {[
                { label: "Home", path: "/" },
                { label: "Services", path: "/services" },
                { label: "About", path: "/about" },
                { label: "Case Studies", path: "/case-studies" },
                { label: "Blog", path: "/blog" },
                { label: "Contact", path: "/contact" },
                { label: "AI for Business", path: "/ai-for-business" },
                { label: "Ofsted Reports", path: "/ofsted-reports" },
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-primary-foreground/70 hover:text-accent transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-primary-foreground mb-3 text-sm">Services</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/70">
              <li>Apprenticeship Intelligence Platform</li>
              <li>AI Governance Framework</li>
              <li>Quality Operating System</li>
              <li>90-Day Performance Reset</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-primary-foreground/10 mt-10 pt-6 text-center text-xs text-primary-foreground/50">
          © {new Date().getFullYear()} QA 1st. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
